commusoftCommon.filter('dateTimeLineFromNow', function (CS_LANGUAGE) {
    return function (dateString) {
        moment.locale(CS_LANGUAGE);
        return moment(dateString).fromNow(true);
    };
});